import React from "react";
import { Layout as AntdLayout, Row, Col } from "antd";
import { InstagramOutlined, MailOutlined } from "@ant-design/icons";
import styled from "@emotion/styled";

const CustomFooter = styled(AntdLayout.Footer)({
  backgroundColor: "darkgreen",
  color: "white",
  height: "120px",
  textAlign: "center",
});

const Footer: React.FC = (): JSX.Element => (
  <CustomFooter>
    <Row>
      <Col span={24} style={{ marginBottom: "12px" }}>
        <a href="https://www.instagram.com/kika_holland.bv/">
          <InstagramOutlined className="zoom" style={{color:"lightyellow", fontSize:"32px"}}/>
        </a>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <a href="mailto:info@kikaholland.com">
          <MailOutlined className="zoom" style={{color:"lightyellow", fontSize:"32px"}}/>
        </a>
      </Col>
    </Row>
    <p style={{color:"lightyellow"}}>© Kika Holland BV 2024</p>
  </CustomFooter>
);

export default Footer;
